import React from "react";
import classNames from "classnames";

type Props = {
  title: string;
  options: {
    selected: boolean;
    title: string;
  }[];
};

const StrainGrowInfoRow = ({ title, options }: Props): JSX.Element => (
  <div>
    <div className="text-left capitalize mb-sm font-bold font-sm text-default">
      {title}
    </div>
    <div className="flex flex-row w-full mb-lg items-center">
      {options.map((option, i) => {
        return (
          <div
            className={classNames(
              "flex-1 py-sm text-center text-sm rounded-l-full font-bold",
              option.selected
                ? "border border-grey rounded-full px-md bg-white"
                : "text-grey"
            )}
            dangerouslySetInnerHTML={{ __html: option.title }}
            key={`${title}-${i}`}
          ></div>
        );
      })}
    </div>
  </div>
);
export default StrainGrowInfoRow;
